<template lang="html">
<div class="pgInner userFill" :style="'height:' + pageH + 'px;'">
    <el-scrollbar ref="pgScroller" style="height:100%;">

        <div class="pgHead">
            <span>朝企家 | 重置密码</span>
            <el-button @click="goReturn" class="btn" size="small" type="primary">返回</el-button>
        </div>

        <div class="pgBody" :style="'height:' + (pageH-60) + 'px;'" >

          <el-steps :active="pgress">
              <!-- <el-step title="输入身份证信息"></el-step> -->
              <el-step title="验证手机号"></el-step>
              <el-step title="设置新密码"></el-step>
          </el-steps>

            <!-- <div v-show="pgress==1" class="inpCage">
                  <el-form ref="form1" :model="params1" :rules="rules1" :show-message="false">

                      <div class="inpLine">
                          <el-form-item prop="name">
                              <el-input v-model="params1.name" placeholder="姓名" />
                          </el-form-item>
                      </div>
                      <div class="inpLine">
                          <el-form-item prop="idCard">
                              <el-input v-model="params1.idCard" placeholder="身份证号" />
                          </el-form-item>
                      </div>

                      <div class="inpLine subline">
                          <el-button @click="goSet(1)" type="primary">下一步</el-button>
                      </div>
                  </el-form>
            </div> -->

            <div v-show="pgress==1" class="inpCage">
                  <el-form ref="form2" :model="params2" :rules="rules2" :show-message="false">
                      <div class="inpLine">
                           <!-- <div class="codetips">点击获取验证码，短信验证码将发送至手机 {{params2.phone|transCode(1)}}</div> -->
                           <div class="codetips">请输入注册时的手机号进行身份验证</div>
                      </div>
                        <div class="inpLine">
                          <el-form-item prop="phone">
                              <el-input v-model="params2.phone" placeholder="请输入手机号" />
                          </el-form-item>
                      </div>
                      <div class="inpLine codeLine">
                          <el-form-item prop="smsCode">
                                <el-input v-model="params2.smsCode" placeholder="请输入验证码" />
                          </el-form-item>
                          <el-button v-if="wTime===0" @click="getCode" class="cbtn" type="primary">获取验证码</el-button>
                          <el-button v-else disabled class="cbtn disbtn" type="primary">{{wTime}}s</el-button>
                      </div>

                      <div class="inpLine subline">
                          <el-button @click="goSet(2)" :loading="loading" type="primary">下一步</el-button>
                      </div>
                  </el-form>
            </div>

            <div v-show="pgress==2" class="inpCage">
                  <el-form ref="form3" :model="params3" :rules="rules3" :show-message="false">
                      <div class="inpLine">
                           <div class="codetips">请设置{{params2.phone|transCode(1)}}的新密码，建议使用数字、字母、字符的组合提高密码安全等级</div>
                      </div>

                      <div class="inpLine">
                          <el-form-item prop="idCard">
                              <el-input v-model="params3.pwd" placeholder="8-16位密码，区分大小写" />
                          </el-form-item>
                      </div>

                      <div class="inpLine subline">
                          <el-button @click="goSet(3)" type="primary">确定</el-button>
                      </div>
                  </el-form>
            </div>



        </div>

    </el-scrollbar>

</div>
</template>

<script>
import Cookies from 'js-cookie';
import { paramsCreate } from "@/utils/iparams";
import { requestSmsCode,codeCheck,registerRecode,getPhone } from "@/api/pgMent/userMent";

var mobelPhone = (rule,val,callback) => {      // 手机验证
     var pattern = /^1(3|4|5|7|8)\d{9}$/;

     if(val == ''){
         callback(new Error('请输入手机号'));
     }else if(!pattern.test(val)){
         callback(new Error('手机号格式错误！'));
     }else{
         callback();
     }
};

var idCard = (rule,val,callback) => {
      var pattern = /^([1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx])|([1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2})$/;
     if(val == ''){
         callback(new Error('请输入身份证号'));
     }else if(!pattern.test(val)){
         callback(new Error('身份证号错误'));
     }else{
         callback();
     }
};


export default {
    filters:{
          transCode:function(e,type){
              if(type == 1){
                  if(e){
                      return e.substr(0,3) + "****" + e.substr(7,11);
                  }
              }
          }
    },
    data(){
        return{
            pageH:'',
            pgress:1,
            isWait:false,
            userData:{},
            wTime:0,
            loading:false,
            // params1:{
            //     name:'',
            //     idCard:''
            // },
            params2:{
               phone:'',
               smsCode:''
            },
            params3:{
               phone:'',
               pwd:''
            },
            // rules1:{
            //     name:[{ required: true,trigger: 'blur' }],
            //     idCard:[{ validator: idCard,trigger: 'blur' }]
            // },
            rules2:{
                phone:[{ required: true,trigger: 'blur' }],
                smsCode:[{ required: true,trigger: 'blur' }]
            },
            rules3:{
                pwd:[{ required: true,trigger: 'blur' }]
            }
        }
    },
    methods:{

        pageFix:function(){
            this.pageH = document.documentElement.clientHeight - 50;
        },

        goWait:function(){
            var vues = this;
            vues.wTime = 60;
            vues.wait = setInterval(function(){
                vues.wTime--;
                if(vues.wTime === 0){
                    clearInterval(vues.wait);
                }
            },1000)
        },

        getCode:function(){
            var cTime = 60;
            var vues = this;
            if(!this.params2.phone){
                this.$message.error('请先填写手机号')
            }else{
                var newPms = paramsCreate();
                requestSmsCode({
                    cellphone:this.params2.phone,
                    type:5,
                    t:newPms.t,
                    r:newPms.r,
                    s:newPms.s
                }).then(res => {
                    vues.goWait();
                })
            }
        },

        formClear:function(){
            for(var key in this.params){
                this.params[key] = '';
            }
        },

        goSet:function(type){
            var vues = this;
            if(type == 1){
                vues.$refs.form1.validate((valid) => {
                    if(valid){
                        getPhone(vues.params1).then(res => {
                            vues.params2.phone = res.phone;
                            vues.params3.phone = res.phone;
                            vues.pgress = 2;
                        })
                    }
                })
            }else if(type == 2){
                vues.$refs.form2.validate((valid) => {
                    if(valid){
                        vues.loading=true;
                          codeCheck({
                              cellphone:vues.params2.phone,
                              smsCode:vues.params2.smsCode
                          }).then(res => {
                              vues.loading=false;
                              vues.pgress = 2;
                          })

                    }
                })
            }else{
                vues.$refs.form3.validate((valid) => {
                    if(valid){
                      registerRecode({
                          cellphone:vues.params2.phone,
                          verifyCode:vues.params2.smsCode,
                          pwd:vues.params3.pwd
                      }).then(res => {
                          vues.$message.success('设置成功!');
                          vues.$router.replace('login');
                      })
                    }
                })
            }

        },

        goReturn:function(){
            this.$router.go(-1);
        }

    },

    created:function(){
        var vues = this;

        this.userData = this.$store.getters.userInfo;

        this.pageFix();


    }
}
</script>

<style lang="scss" scoped>

.pgInner{
  background: #f5f5f5;
}

.pgHead{
     height: 60px;
     line-height: 60px;
     padding-left: 30px;
     font-size: 16px;

     .btn{
         float: right;
         width: 80px;
         margin-right: 30px;
         margin-top: 15px;
     }
}

.seek-blcok{
     margin: 0 30px;
     background: white;
     padding: 30px;

     .ttl{
         font-size: 15px;
         font-weight:bold;
     }

     .content{
         margin-top: 20px;
     }

}

.pgBody{
    margin: 0 30px;
    padding: 30px;
    background: white;

    .inpCage{
        width: 450px;
        margin: 0 auto;
        margin-top: 120px;

        .inpLine{
            margin-bottom: 18px;
            .el-form-item{
                margin-bottom: 0px;
                display: block;
            }

            .codetips{
                font-size: 14px;
                color: #999999;
                margin-bottom: 30px;
            }
        }

        .codeLine{
           .el-input{
               width: 320px;
           }
            .cbtn{
                float: right;
            }

            .el-form-item{
                display: inline-block;
            }
        }

        .subline{
            text-align: center;
            margin-top: 30px;
            .el-button{
                width: 100%;
                height: 45px;
            }
        }

        .sucLine{
           color: #999999;
           text-align: center;
           margin-bottom: 80px;

           .icon{
               font-size: 30px;
               vertical-align: middle;
               margin-bottom: 6px;
           }
        }

        .firmCheck{
            font-size: 14px;
            color: #666666;

            .el-checkbox{
                margin-right: 3px;
            }

            .spanLink{
                color: #409EFF;
                cursor: pointer;
            }
        }


    }
}

.disbtn{
    pointer-events: none;
    width: 112px;
}

.userFill .el-form-item{
     display: inline-block;
}

</style>



// WEBPACK FOOTER //
// passReset.vue?2181684a